import { FAQ } from "@/components";
import data from "./data";
import { useState } from "react";

export const FAQsPage = () => {
  const [id, setId] = useState("");

  return (
    <div className="container py-16 mx-auto">
      <div className="flex flex-col gap-12 lg:gap-16">
        {data.map(({ title, questions }, sIdx) => (
          <div className="flex flex-col gap-6 lg:gap-8" key={sIdx}>
            <div className="text-2xl md:text-3xl lg:text-4.5xl text-white font-medium">{title}</div>

            <div className="flex flex-col gap-4 lg:gap-6">
              {questions.map((item, qIdx) => {
                const qId = `${sIdx}-${qIdx}`;

                return (
                  <FAQ
                    key={qIdx}
                    {...item}
                    onOpen={() => setId(qId)}
                    opened={id === qId}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
